// React
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material UI
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Icon } from '@mui/material';
// Actions
import AccountAction from 'actions/AccountAction';
import Loader from 'components/commons/Loader';
//Styles
import { useStyles } from 'components/dialogs/account/DialogAccount.style';
//Pcp components
import ModuleDisplay from 'components/dialogs/account/ModuleDisplay';

const MODULES = [{
    name: 'spe',
    icon: 'euro_symbol'
}, {
    name: 'perf',
    icon: 'trending_up'
}, {
    name: 'adbox',
    icon: 'mail'
}, {
    name: 'mail',
    icon: 'drafts'
}, {
    name: 'slider',
    icon: 'calendar_view_day'
}];

const DialogAccountModules = ({
    account,
    close,
    open
}) => {
    const classes = useStyles();
    const modules = MODULES.filter(m => account.modules[m.name]);

    const [activeModule, setActiveModule] = useState(0);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (open) {
            getData();
        }
    }, [open, activeModule]);

    const getData = () => AccountAction.getModule(account.id, modules[activeModule].name).then(d => setData(d));

    const renderContent = () => {
        switch (modules[activeModule].name) {
        case 'spe':
            return <ModuleDisplay moduleSites={data} />;
        case 'perf':
            return <ModuleDisplay moduleSites={data} />;
        case 'adbox':
            return <ModuleDisplay moduleSites={data.sites} moduleInfos={data.credentials} />;
        case 'slider':
            return <ModuleDisplay moduleSites={data} />;
        case 'mail':
            return <ModuleDisplay moduleInfos={{ [`DM envoyés à ${data.sending_hour}h `]: data.emails }} />;
        default:
            return <div></div>;
        }
    };

    return <Dialog
        open={open}
        onClose={close}
        disableRestoreFocus={true}
        aria-labelledby='responsive-dialog-title'
        classes={{
            paper: classes.dialogPaper
        }}
    >
        <DialogContent>
            <Tabs value={activeModule} onChange={(event, newValue) => setActiveModule(newValue)}
                indicatorColor='primary'
                textColor='primary'
                classes={{
                    indicator: classes.indicator
                }}>
                {modules.map((m, key) => <Tab key={key}
                    icon={<Icon color='primary' key={m.name}>{m.icon}</Icon>}
                    label={m.name}
                    className={classes.tab} />)}
            </Tabs>
            {!data ? <div className={classes.loaderContainer}><Loader size={50} /></div> : renderContent()}
        </DialogContent>
    </Dialog>;

};

DialogAccountModules.propTypes = {
    close: PropTypes.func,
    exportData: PropTypes.func,
    account: PropTypes.object,
    open: PropTypes.bool,
    fullScreen: PropTypes.bool,
};

export default DialogAccountModules;
